<template>
    <l-map
        id="map"
        style=""
        :use-global-leaflet="true"
        :options="mapOptions"
        v-model:zoom="zoom"
        v-model:center="center"
        v-model:bounds="bounds"
        :min-zoom="minZoom"
        :max-zoom="maxZoom"
        :zoom-animation="false"
        :scrollWheelZoom="false"
        :noBlockingAnimations="true"
        @ready="onReady()"
        ref="map"
    >
        <template v-if="true"><!-- leafletReady -->

            <l-tile-layer
                v-for="(tileProvider) in tileProviders"
                :key="tileProvider.id"
                :name="tileProvider.name"
                :url="tileProvider.url+(apiKeys[tileProvider.token] ? apiKeys[tileProvider.token] : '')"
                :attribution="tileProvider.attribution"
                :subdomains="tileProvider.subdomains"
                :x-options="tileProvider.options"
                :x-token="apiKeys[tileProvider.token]"
                :visible="tileProvider.visible"
                layer-type="base"
            />

            <!-- controls in map -->
            <l-control-zoom :position="zoomPosition"/>

            <l-control-layers
                :position="layersPosition"
                :collapsed="false"
            />
            <!-- end controls in map -->

            <l-control-attribution
                :position="attributionPosition"
                :prefix="attributionPrefix"
            />
            <l-control-scale v-bind="unitsOfMeasure"/>
            <!-- <l-icon-default :image-path="path" /> -->

            <!-- units layers -->
            <SectionMap_layer_units v-model="overlay.units" v-if="leafletReady"/>
            <SectionMap_layer_unit_edit v-model="overlay.unit_edit" v-if="leafletReady"/>
            <!--  end units layers -->
            <!-- unit_zone layers -->
            <SectionMap_layer_unit_zone v-model="overlay.unit_zone" v-if="leafletReady"/>
            <!-- unit_zone layers -->

            <!-- units groups layers -->
            <SectionMap_layer_units_groups v-model="overlay.units_groups" v-if="leafletReady"/>
            <!--  end groups units layers -->

            <!-- geoitems layers -->
            <SectionMap_layer_geoitems v-model="overlay.geoitems" v-if="leafletReady"/>
            <SectionMap_layer_geoitem_edit v-model="overlay.geoitem_edit" v-if="leafletReady"/>
            <!-- geoitems layers -->

            <!-- track layers -->
            <SectionMap_layer_tracks v-model="overlay.tracks" v-if="leafletReady"/>
            <SectionMap_layer_track_by_points v-model="overlay.track_by_points" v-if="leafletReady"/>

            <SectionMap_layer_greensee_tracks v-model="overlay.greensee_tracks" v-if="leafletReady"/>
            <!-- end track layers -->

            <!-- notificatons layers -->
            <SectionMap_layer_notificatons v-model="overlay.notifications" v-if="leafletReady"/>
            <!-- end notificatons layers -->

            <template v-if="$consts.app.$isIntuit">
            <!-- Shipment -->
            <SectionMap_layer_shipments_tracks v-model="overlay.shipments_tracks" v-if="leafletReady"/>
            <SectionMap_layer_shipments_units v-model="overlay.shipments_units" v-if="leafletReady"/>
            <!-- end Shipment -->
            </template>

            <template v-if="$consts.app.$isPrometheus">
            <SectionMap_layer_smart_search_tracks v-model="overlay.smartSearch"  v-if="leafletReady"/>
            </template>

        </template>
    </l-map>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
// import "leaflet-draw/dist/leaflet.draw.css";
// import "leaflet-toolbar/dist/leaflet.toolbar.css";

import {computed} from "vue";
import debounce from "lodash/debounce"
import {mapGetters} from "vuex";

import 'leaflet'
import * as L from 'leaflet'
// import * as L from 'leaflet/dist/leaflet-src.esm.js';

// import 'leaflet-draw/dist/leaflet.draw-src.js'
// import 'leaflet-polylinedecorator'

import {
    LControlAttribution,
    LControlLayers,
    LControlScale,
    LControlZoom,
    // LLayerGroup,
    // LControl,
    // LFeatureGroup,
    // LCircle,
    // LPolygon,
    // LPolyline,
    // LTooltip,
    // LPopup,
    // LIcon,
    LTileLayer,
    LMap
} from "@vue-leaflet/vue-leaflet";
import {useToast} from "vue-toastification";
import {getImageOptions, htmlToElement} from "@/lib/lib";
import consts from "@/consts/intuit.";

import SectionMap_layer_geoitems from "@/components/app/SectionMap_layer_geoitems.vue";
import SectionMap_layer_geoitem_edit from "@/components/app/SectionMap_layer_geoitem_edit.vue";
import SectionMap_layer_unit_zone from "@/components/app/SectionMap_layer_unit_zone";
import SectionMap_layer_tracks from "@/components/app/SectionMap_layer_tracks.vue";
import SectionMap_layer_greensee_tracks from "@/components/app/SectionMap_layer_greensee_tracks.vue";
import SectionMap_layer_notificatons from "@/components/app/sectionMap_layer_notificatons.vue";
import SectionMap_layer_shipments_tracks from "@/components/app/SectionMap_layer_shipments_tracks.vue";
import SectionMap_layer_shipments_units from "@/components/app/SectionMap_layer_shipments_units.vue";
import SectionMap_layer_track_by_points from "@/components/app/SectionMap_layer_track_by_points";
import SectionMap_layer_units from "@/components/app/SectionMap_layer_units.vue";
import SectionMap_layer_unit_edit from "@/components/app/SectionMap_layer_unit_edit.vue";
import SectionMap_layer_smart_search_tracks from "@/components/app/SectionMap_layer_smart_search_tracks";
import SectionMap_layer_units_groups from "@/components/app/SectionMap_layer_units_groups";

export default {
    setup(){
        return {
            debounceFn: debounce((fn) => {
                if(typeof fn == 'function') fn();
            }, 300)
        }
    },
    name: 'SectionMap',
    mixins: [],
    props: {
    },
    components: {
        SectionMap_layer_notificatons,
        SectionMap_layer_shipments_tracks,
        SectionMap_layer_shipments_units,
        SectionMap_layer_unit_edit,
        SectionMap_layer_track_by_points,
        SectionMap_layer_geoitems,
        SectionMap_layer_geoitem_edit,
        SectionMap_layer_unit_zone,
        SectionMap_layer_tracks,
        SectionMap_layer_greensee_tracks,
        SectionMap_layer_units,
        SectionMap_layer_units_groups,
        SectionMap_layer_smart_search_tracks,

        LMap,
        LTileLayer,
        LControlZoom,
        LControlAttribution,
        LControlScale,
        LControlLayers,
        // LLayerGroup,
        // LControl,
        // LCircle,
        // LPolygon,
        // LPolyline,
        // LIcon,
        // LTooltip,
        // LMovingMarker,
        // LFeatureGroup,
        //'l-marker-cluster': Vue2LeafletMarkerCluster,
        // 'l-tile-layer-googlemutant': Vue2LeafletGoogleMutant,
    },
    data() {
        return {
            L,
            toast: useToast(),
            leafletReady: false,
            map: null,
            mapOptions: {
                useGlobalLeaflet: true,
                zoomControl: false,
                attributionControl: false,
                zoomSnap: false,
            },
            minZoom: 2.5,
            maxZoom: 18,
            zoom: 12,
            center: {lat: 25.761681, lng: -80.191788},
            bounds: null, //L.latLngBounds({lat: 25.761681, lng: -80.191788}, {lat: 25.761681, lng: -80.191788}),

            openGeozoneEditControlPosition: 'topright',
            zoomPosition: 'topright',
            layersPosition: 'topright',
            attributionPosition: 'bottomright',
            attributionPrefix: 'Vue2Leaflet',
            imperial: false,
            Positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],
            tileProviders: [
                {
                    id: 'osm',
                    name: 'OpenStreetMap',
                    visible: true,
                    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    token: '',
                },
                // {
                //     name: 'OpenTopoMap',
                //     visible: false,
                //     url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                //     attribution: 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
                //     token: '',
                // },

                //h = roads only
                //m = standard roadmap
                //p = terrain
                //r = somehow altered roadmap
                //s = satellite only
                //t = terrain only
                //y = hybrid
                //https://stackoverflow.com/questions/9394190/leaflet-map-api-with-google-satellite-layer
                //Hybrid: s,h;
                //Satellite: s;
                //Streets: m;
                //Terrain: p;
                {
                    id: 'google',
                    name: 'Google',
                    visible: false,
                    url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=' + this.$i18n.locale + '&key=',//+ '&key=AIzaSyDPkqJnWr_oHIrgV_xj0Sk-2SyyZg0udxk',
                    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                    options: {
                        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                        //accessToken: '',
                        key: () => this.apiKeys['googleKey']
                    },
                    token: 'googleKey',
                },
                {
                    id: 'google-hybrid',
                    name: 'Google-Hybrid',
                    visible: false,
                    url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&hl=' + this.$i18n.locale + '&key=',//+ '&key=AIzaSyDPkqJnWr_oHIrgV_xj0Sk-2SyyZg0udxk',
                    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                    options: {
                        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                        //accessToken: '',
                        key: () => this.apiKeys['googleKey']
                    },
                    token: 'googleKey',
                },
                {
                    id: 'google-traffic',
                    name: 'Google Traffic',
                    visible: false,
                    url: 'https://{s}.google.com/vt/lyrs=m,traffic&x={x}&y={y}&z={z}&hl=' + this.$i18n.locale + '&key=',//+ '&key=AIzaSyDPkqJnWr_oHIrgV_xj0Sk-2SyyZg0udxk',
                    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                    options: {
                        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                        //accessToken: '',
                        key: () => this.apiKeys['googleKey']
                    },
                    token: 'googleKey',
                },
            ],

            overlay: {
                // 'moving marker': {visible: true},
                units: {name: this.$t('map.layer.Units'), visible: false, type: 'overlay', showLayer: false},
                unit_edit: {name: this.$t('map.layer.Unit Edit'), visible: false, type: '-', showLayer: false},
                unit_zone: {name: this.$t('map.layer.Unit zone'), visible: true, type: '-', showLayer: true},
                units_groups: {name: this.$t('map.layer.Units Groups'), visible: false, type: '-', showLayer: false},
                geoitems: {name: this.$t('map.layer.Geo items'), visible: false, type: 'overlay', showLayer: false},
                geoitem_edit: {name: this.$t('map.layer.Geoitem edit'), visible: false, type: '-', showLayer: false},
                tracks: {name: this.$t('map.layer.Track'), visible: false, type: '-', showLayer: false},
                greensee_tracks: {name: this.$t('map.layer.Track'), visible: false, type: '-', showLayer: false},
                notifications: {name: this.$t('map.layer.Notifications'), visible: false, type: '-', showLayer: false},
                shipments_units: {name: this.$t('map.layer.Shipment Unit'), visible: false, type: '-', showLayer: false},
                shipments_tracks: {name: this.$t('map.layer.Track'), visible: false, type: '-', showLayer: false},
                track_by_points: {name: this.$t('map.layer.Track'), visible: false, type: '-', showLayer: false},
                smartSearch: {name: this.$t('map.layer.Units Smart Search'), visible: false, type: '-', showLayer: false},
            },

            path: "/img/",
            unitIcon: L.icon({
                iconUrl: require('@/assets/img/unit/common__car_lg.png'),
                iconSize: [32, 32],
                iconAnchor: [16, 16],
                popupAnchor: [4, -25],
            }),
        }
    },
    provide() {
        return {
            // page: computed(() => this.page),
            L: computed(() => this.L),
            unitIcon: computed(() => this.unitIcon),
            createMarker: (latLng, iconOptions, popupOptions) => this.createMarker(latLng, iconOptions, popupOptions),
            unitIconByType: (params) =>  this.unitIconByType(params),
            mapLeafletObject: computed(() => this.map),
            toast: computed(() => this.toast),
            mapBounds: computed(() => this.bounds),
            disabledMapEvents: () => this.disabledMapEvents(),
            enableMapEvents: () => this.enableMapEvents(),
        }
    },
    computed: {
        ...mapGetters([
            "getAppUser",
            "getAppUserSettings",
            "getUserStorageKey",
            "getAppUserUnits",

            "getMapCenter",
            "getMapZoom",
            "getMapBounds",

            "getTheme"
        ]),
        layersByRoute() {
            return this.routeMeta.layers || {};
        },
        unitsOfMeasure() {
            return consts.units_of_measure.reduce((unitsOfMeasure, u) => {
                unitsOfMeasure[u] = (u == this.getAppUser?.units_of_measure)
                return unitsOfMeasure
            }, {})
        },
        speedUnits() {
            return this.getAppUserUnits.speed
        },
        apiKeys() {
            return this.getAppUser?.map_apikeys || {}
        },
        _tileProviders() {
            let _tileProviders = this.tileProviders
            let keys = this.tileProviders.reduce((keys, t) => {
                if (t.token > '') {
                    if (!keys.includes(t.token)) keys.push(t.token)
                }
                return keys
            }, [])
            keys.forEach(k => {
                if (!this.apiKeys[k]) {
                    _tileProviders = _tileProviders.filter(t => t.token != k)
                }
            })
            _tileProviders = _tileProviders.map(o => {
                o.visible = o.name === (this.routeMeta.mapType || 'OpenStreetMap')
                return o
            })
            //console.log('tileProviders', _tileProviders.map(t => t.name))
            return _tileProviders
        },
    },
    watch: {
        getTheme: {
          handler: function () {
              this.setMapStyle()
          },
          immediate: true,
        },
        routeName: {
            handler: function (newVl, oldVl) {
                // console.log('routeName', newVl, oldVl)
                if (newVl != oldVl) {
                    this.debouncedInvalidateMapSize();
                }
            }
        },
        layersByRoute: {
            handler: function () {
                //console.log('layersByRoute', nVal, this.overlay)
                this.debounceFn(this.updateOverlay)
            },
            deep: true,
            immediate: true,
        },
        getMapCenter: {
            //ToDo fix
            handler: function (newVl, oldVl) {
                if (!newVl) return;
                if (newVl) {
                    console.warn('MapCenter', {...newVl}, {...oldVl}, this.center)
                    //this.center = newVl
                    this.map?.setView(newVl, undefined, {animate: false})
                }
            }
        },
        getMapZoom: {
            handler: function (newVl, oldVl) {
                if (!newVl) return;
                if (newVl) {
                    if(this.$isDevelopment) console.log('MapZoom', newVl, oldVl, this.zoom)
                    //this.zoom = newVl
                    this.map.setZoom(newVl)
                }
            }
        },
        getMapBounds: {
            //ToDo fix
            handler: function (newVl, oldVl) {
                if (!newVl) return;
                if(this.$isDevelopment) console.log('MapBounds', newVl, oldVl);
                if (Array.isArray(newVl)) {
                    let paddingBounds = this.getMapPaddingBounds || this.$consts.components.map.paddingBounds
                    if(this.$isDevelopment) console.log('fitBounds MapBounds', newVl, oldVl);
                    this.map.fitBounds(this.L.latLngBounds(newVl), paddingBounds)
                    // newVl = this.L.latLngBounds(newVl).pad(0.2)
                } else {
                    if(this.$isDevelopment) console.log('fitBounds MapBounds', newVl, oldVl);
                    this.map.fitBounds(newVl)
                    // newVl = this.L.latLngBounds(newVl)
                }
            }
        },
    },
    methods: {
        setMapStyle() {
            //ToDo fix
/*
            this.tileProviders.forEach(t => {
                t.visible = false
            })
            if (this.getTheme == this.$consts.themes.dark) {
                let tile = this.tileProviders.find(t =>  t.name == 'Google-Hybrid')
                if (tile) tile.visible = true
            } else {
                let tile = this.tileProviders.find(t =>  t.name == 'OpenStreetMap')
                if (tile) tile.visible = true
            }
*/
        },
        disabledMapEvents() {
            this.map.scrollWheelZoom.disable();
            this.map.dragging.disable();
        },
        enableMapEvents() {
            this.map.scrollWheelZoom.enable();
            this.map.dragging.enable();
        },
        getIcon(unit) {
            return this.L.icon({
                iconUrl: unit.icon || require('@/assets/img/unit/common__car_lg.png'),
                iconSize: [21, 31],
                iconAnchor: [16, 16],
                popupAnchor: [4, -25],
            })
        },
        async createMarker(latLng, options = {}) {
            let markerOptions = await getImageOptions(options.icon)
            let iconSize = markerOptions?.icon?.iconSize
            if (!markerOptions || !(iconSize[0] * iconSize[1])) {
                console.error('createMarker', markerOptions?.icon)
                return null;
            }
            let iconAnchor = iconSize.map((sz, i) => sz * (options.icon?.anchorK[i] || 0))
            let popupAnchor = iconSize.map((sz, i) => sz * (options.popup?.anchorK[i] || 0))
            let tooltipAnchor = iconSize.map((sz, i) => sz * (options.tooltip?.anchorK[i] || 0))
            let meta = {...options.meta}
            delete options.meta

            markerOptions = {
                ...options,
                ...markerOptions,
                icon: this.L.icon({
                    ...markerOptions.icon,
                    iconAnchor,
                    popupAnchor,
                    tooltipAnchor,
                }),
            }

            if (!Array.isArray(latLng) && typeof latLng === 'string') latLng = latLng.split(',')
            let marker = this.L.marker(latLng, markerOptions);
            marker.meta = meta
            return marker
        },

        DrawPolylineOnMap() {
            return false;
        },
        updateOverlay() {
            Object.keys(this.overlay)
                .forEach(k => {
                    this.overlay[k].visible = !!this.layersByRoute[k]?.visible;
                    this.overlay[k].type = this.layersByRoute[k]?.showInList ? 'overlay' : '-';
                    this.overlay[k].showLayer = !!this.layersByRoute[k]?.showLayer;
                })
        },
        async onReady() {
            // const { MarkerClusterGroup } = await import("leaflet.markercluster/dist/leaflet.markercluster-src.js");
            await this.$nextTick();
            // debugger
            this.$nextTick().then(() => {
            // setTimeout(() => {
            this.map = this.$refs.map.leafletObject
            this.map.invalidateSize()
            this.leafletReady = true;

            if(this.$isDevelopment) console.log(`SectionMap onReady`);
            this.resizeObserver()
            // }, 1000)
            })
        },
        resizeObserver() {
            let map = document.getElementById("map")
            // console.log('section map', !!map)
            if (map) {
                new ResizeObserver(() => {
                    let map = document.getElementById("map");
                    // console.log('sectionMap.invalidateSize', map.offsetWidth, map.offsetHeight)//, map.innerWidth, map.innerHeight)
                    if (map?.offsetWidth && map?.offsetHeight) this.debouncedInvalidateMapSize()
                    else if(this.$isDevelopment) {console.log('sectionMap.invalidateSize')}
                }).observe(map)
            }
        },
        invalidateMapSize() {
            if (!this.map) return
            let bounds = this.bounds ? [{...this.bounds.getNorthEast()}, {...this.bounds.getSouthWest()}] : null //this.map.getBounds()
            // console.log('map.invalidateSize', toRaw(this.bounds), bounds)
            this.map.invalidateSize()
            if (bounds) this.map.fitBounds(bounds)
        },
        unitIconByType(params, hideName = false) {
            params = params || {}
            let html = '';
            let [styleIcon, styleName] = ['styleIcon', 'styleName']
                .map(s => Object.keys(params[s] || {})
                    .filter(k => params[s][k])
                    .map(k => k + ':' + params[s][k])
                    .join(';')
                );

            switch (params.type) {
                case 'ble_gateway': {
                    let img_src = '/img/icons.svg#map__pin-bles';
                    html = '<div class="unit-marker"' + (hideName ? 'unit-marker-label-hide' : '') + '>' +
                        '<div class="unit-marker-svg-icon" style="width: 42px; height: 62px">' +
                        '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg" style="width: 42px; height: 62px">' +
                        '<use xlink:href="' + img_src + '"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="leaflet-label unit-marker-label" style="' + styleName + '">' + params.name + '</div>' +
                        '</div>';

                    html = htmlToElement(html);
                    return this.L.divIcon({
                        className: 'direction-enabled' + (params.icon_has_halo ? ' has-halo' : ''),
                        iconSize: [42, 118],
                        html,
                    })
                }
                default: {
                    html = '<div class="unit-marker ' + (params.icon_has_halo ? 'unit-marker-has-halo' : '') + (hideName ? 'unit-marker-label-hide' : '') +'">' +
                        '<div class="unit-marker-svg-icon ' + params.statusClass + '" style="' + styleIcon + '">' +
                        '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg">' +
                        '<use xlink:href="' + params.img_src + '"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="leaflet-label unit-marker-label" style="' + styleName + '">' + params.name + '</div>' +
                        '</div>';

                    html = htmlToElement(html);
                    return this.L.divIcon({
                        className: 'direction-enabled' + (params.icon_has_halo ? ' has-halo' : ''),
                        iconSize: [32, 32],
                        html,
                    })
                }
            }
        }
    },
    created: function () {
        this.debouncedInvalidateMapSize = debounce(this.invalidateMapSize, 800)
        // console.log(`SectionMap created`);
    },
    async beforeMount() {
        // HERE is where to load Leaflet components!
        //this.L = await import("leaflet/dist/leaflet");
        //await import("leaflet/dist/leaflet")
        // this.unitIcon = this.L.icon({
        //     iconUrl: require('@/assets/img/unit/common__car_lg.png'),
        //     iconSize: [32, 32],
        //     iconAnchor: [16, 16],
        //     popupAnchor: [4, -25],
        // })
        // this.mapIsReady = true;
        if(this.$isDevelopment) console.log(`SectionMap beforeMount`);
    },
    updated() {
        if(this.$isDevelopment) console.log(`SectionMap updated`, this.zoom);
    },
    mounted() {
    },
}
</script>

<style lang="scss">
.leaflet-container {
    padding: 20px;

    .leaflet-control-container {
        background: red;

        .leaflet-top.leaflet-left {
            //background: red;
            left: initial;
            top: 3.75rem;
            right: .75rem;
            bottom: .75rem;

            .leaflet-control-zoom {
                margin: 0;
                border: 0;
                box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), .3);

                .leaflet-control-zoom-in,
                .leaflet-control-zoom-out {
                    height: 40px;
                    width: 40px;
                    background: rgba(var(--color-white-rgb), .75);
                    color: rgba(var(--color-white-rgb), 0);
                    font-size: 0;
                    user-select: none;
                    position: relative;

                    &:before {
                        content: '';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 1rem;
                        height: .125rem;
                        background: var(--color-neutral-400);
                        border-radius: .125rem;
                    }

                    //.symbol__image { content:url("~@/assets/img/common__boat_lg.png"); }

                    &:hover {
                        background: rgba(var(--color-white-rgb), .85);
                    }

                    &:active {
                        background: rgba(var(--color-white-rgb), 1);
                    }
                }

                .leaflet-control-zoom-in {
                    border-radius: .5rem .5rem 0 0;
                    border-bottom: 1px solid var(--color-neutral-100);

                    &:after {
                        content: '';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: .125rem;
                        height: 1rem;
                        background: var(--color-neutral-400);
                        border-radius: .125rem;
                    }
                }

                .leaflet-control-zoom-out {
                    border-radius: 0 0 .5rem .5rem;
                }
            }
        }

        .leaflet-control-layers-list {
            background: white;
            padding: .5rem 0;
            border-radius: .5rem;

            .leaflet-control-layers-base {
                label {
                    padding: 8px 12px;
                    user-select: none;
                    @include font(14px, 16px, 400, none, normal, #415C84);

                    &:hover {
                        background: var(--color-primary-25);
                        cursor: pointer;
                    }
                }
            }

            .leaflet-control-layers-separator {
                margin: 8px 0;
            }

            .leaflet-control-layers-overlays {
                label {
                    padding: 8px 12px;
                    user-select: none;
                    @include font(14px, 16px, 400, none, normal, #415C84);

                    span {
                        text-transform: capitalize;
                    }

                    &:hover {
                        background: var(--color-primary-25);
                        cursor: pointer;
                    }
                }
            }
        }

        .leaflet-bottom.leaflet-right {
            .leaflet-control-attribution {
                display: none;
            }
        }

        .leaflet-top.leaflet-right {
            height: 100%;
            right: .75rem;
            padding-top: .75rem;

            .leaflet-control-zoom {
                margin: 0 0 10px;
                border: 0;
                box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), .3);

                .leaflet-control-zoom-in,
                .leaflet-control-zoom-out {
                    height: 40px;
                    width: 40px;
                    background: rgba(var(--color-white-rgb), .75);
                    color: rgba(var(--color-white-rgb), 0);
                    font-size: 0;
                    user-select: none;
                    position: relative;

                    &:before {
                        content: '';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 1rem;
                        height: .125rem;
                        background: var(--color-neutral-400);
                        border-radius: .125rem;
                    }

                    //.symbol__image { content:url("~@/assets/img/common__boat_lg.png"); }

                    &:hover {
                        background: rgba(var(--color-white-rgb), .85);
                    }

                    &:active {
                        background: rgba(var(--color-white-rgb), 1);
                    }
                }

                .leaflet-control-zoom-in {
                    border-radius: .5rem .5rem 0 0;
                    border-bottom: 1px solid var(--color-neutral-100);

                    &:after {
                        content: '';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: .125rem;
                        height: 1rem;
                        background: var(--color-neutral-400);
                        border-radius: .125rem;
                    }
                }

                .leaflet-control-zoom-out {
                    border-radius: 0 0 .5rem .5rem;
                }
            }

            .leaflet-control-layers {
                background: none;
                margin: 0;
                border: none;
                box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), .3);

                .leaflet-control-layers-toggle {
                    height: 40px;
                    width: 40px;
                    background: rgba(var(--color-white-rgb), .75);
                    color: rgba(var(--color-white-rgb), 0);
                    font-size: 0;
                    user-select: none;
                    position: relative;
                    border-radius: .5rem;

                    &:before,
                    &:after {
                        content: '';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        //opacity: .75;
                        width: .875rem;
                        height: .875rem;
                        background: var(--color-neutral-400);
                        border-radius: .125rem;
                        transform: translate(-50%, calc(-50% - 2px)) rotateX(55deg) rotateZ(45deg);
                    }

                    &:after {
                        width: .6875rem;
                        height: .6875rem;
                        transform: translate(-50%, calc(-50% + 4px)) rotateX(55deg) rotateZ(45deg);
                        background: none;
                        border-bottom: 4px solid var(--color-neutral-400);
                        border-right: 4px solid var(--color-neutral-400);
                    }
                }

                &.leaflet-control-layers-expanded {
                    padding: 0;
                }
            }

            .leaflet-control-scale {
                margin: 0;
                position: absolute;
                bottom: .75rem;
                right: 0;

                .leaflet-control-scale-line {
                    border: .0625rem solid var(--color-neutral-300);
                    box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), .3);
                    background: rgba(var(--color-white-rgb), .75);
                    border-top: 0;
                    height: 1.5rem;
                    display: flex;
                    align-items: center;
                    @include font(12px, 16px, 700, none, normal, var(--color-font));
                    border-radius: 0 0 .25rem .25rem;
                }
            }
            .leaflet-control{
                margin: 0 0 10px 0;

                .map-control{
                    background: rgba(var(--color-white-rgb), .75);
                    border: none;
                    padding: 0;
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 0.5rem;
                    box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), 0.3);
                    //transition: .2s;
                    &:hover{
                        background: rgba(var(--color-white-rgb), .85);
                        //transition: .2s;
                    }
                    &:active{
                        background: rgba(var(--color-white-rgb), 1);
                    }
                    .icon{
                        color: #26588d;
                    }
                }
            }
        }

        .leaflet-control-layers-expanded{
            .leaflet-control-layers-list{
                position: absolute;
                right: calc(100% + 10px);;
                top: 0;
                z-index: 12;
                &:after{
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: 100%;
                    display: block;
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-left: 10px solid white;
                }
                label{
                    white-space: nowrap;
                }
            }
            .leaflet-control-layers-scrollbar{
                right: 100%;
            }
            .leaflet-control-layers-toggle{
                display: block;
            }

        }
    }

    .leaflet-pane.leaflet-map-pane {
        //background: red;

        .leaflet-marker-icon {
            /*margin-left: -1.75rem !important;
            margin-top: -1.75rem !important;
            width: 3.5rem !important;
            height: 3.5rem !important;*/

            &:after {
                position: absolute;
                top: 50%;
                left: 50%;
                content: '';
                opacity: 0;
                z-index: -1;
                width: 3.5rem;
                height: 3.5rem;
                background: rgba(var(--map-lable-bg-rgb), .65);
                transform: translate(-50%, -50%);
                border-radius: 50%;
                transition: all 0.6s ease-in-out;

            }

            &.has-halo {
                &:after {
                    opacity: 1;
                }
            }

            &:before {
                position: absolute;
                top: 50%;
                left: 50%;
                content: '';
                z-index: -1;
                width: 5rem;
                height: 3.5rem;
                //background: rgba(var(--color-white-rgb), .5);
                transform: translate(-50%, 0);
                //border-radius: 50%;
            }

            &:hover {
                .leaflet-label {
                    max-width: initial;
                }

                &:after {
                    opacity: 1;
                    width: 4.25rem;
                    height: 4.25rem;
                    transition: all 0.6s cubic-bezier(0.15, 5, 0.5, 0.5);
                    background: rgba(var(--map-lable-bg-rgb), .75);
                }

                &:active {
                    &:after {
                        transition: all 0.2s ease-in-out;
                    }
                }
            }

            &:active {
                &:after {
                    transform: translate(-50%, -50%) scale(.8);
                }
            }

            @for $i from 0 through 360 {
                @if $i % 5 == 0 {
                    &.unit-marker-icon-rotate__#{$i} {
                        .unit-marker-svg-icon {
                            transform: rotate(#{$i}deg) !important;
                        }
                    }
                }
            }

            .unit-marker-svg-icon {
                width: 2rem;
                height: 2rem;
                //transition: all var(--transition-duration-md) ease-in-out;
                transition: all 1s ease-in-out;
            }

            .leaflet-label {
                background: rgba(var(--map-lable-bg-rgb), .9);
                white-space: nowrap;
                width: max-content;
                padding: 0 .5rem;
                //border-radius: var(--border-radius-lg);
                border-radius: .6875rem;
                @include font(13px, 1.375rem, 600, none, normal, var(--color-font));
                position: relative;
                //top: 0;
                height: 1.375rem;
                left: 50%;
                //bottom: -120%;
                transform: translate(-50%, 12px);
                box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), 0.15);
                max-width: 10rem;
                overflow: hidden;
                //display: block;
                text-overflow: ellipsis;
            }

            .unit-marker-badge {
                position: absolute;
                display: block;
                width: 20px;
                height: 20px;
                padding: 2px;
                top: -10px;
                right: -12px;
                background: var(--Blue-Accent-Color);
                border-radius: 100%;
                svg {
                    width: 100%;
                    height: 100%;
                    color: white;
                }
            }

            &.marker-cluster,
            &.marker-cluster-track {
                position: relative;

                div {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    margin: 0;
                    background: rgba(var(--color-success-rgb), .3);
                    min-width: 4.5rem;
                    min-height: 4.5rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 2px solid rgba(var(--color-white-rgb), .4);
                }

                span {
                    @include font(14px, 1.875rem, 700, none, normal, var(--color-white));
                    text-shadow: 0 1px 4px rgba(0, 0, 0, .25);
                }

                &:after,
                &:before {
                    display: none;
                }

                &.marker-cluster-medium {
                    background: var(--color-warning);

                    div {
                        background: rgba(var(--color-warning-rgb), .3);
                    }
                }

                &.marker-cluster-small {
                    background: var(--color-success);
                    max-width: 2rem;
                    max-height: 2rem;
                    border-radius: 50%;

                    div {
                        background: rgba(var(--color-success-rgb), .3);
                    }
                }

                &.marker-cluster-large {
                    background: var(--color-danger);

                    div {
                        background: rgba(var(--color-danger-rgb), .3);
                    }
                }
            }

            &.marker-cluster-track {
                border-radius: 50%;
                background: var(--color-primary-75);
                box-shadow: 0 0 15px rgba(0,0,0, .2);

                div {
                    background: none;
                    min-width: 100%;
                    min-height: 100%;
                    border: 2px solid var(--color-white);
                }

                span {
                    @include font(18px, 1.875rem, 500, none, normal, var(--color-primary-600));
                    text-shadow: none;
                }

                &.medium {
                    margin-left: -1.3125rem !important;
                    margin-top: -1.3125rem !important;
                    max-width: 2.625rem;
                    max-height: 2.625rem;
                }

                &.small {
                    margin-left: -1.1875rem !important;
                    margin-top: -1.1875rem !important;
                    max-width: 2.375rem;
                    max-height: 2.375rem;
                }

                &.large {
                    margin-left: -1.4375rem !important;
                    margin-top: -1.4375rem !important;
                    max-width: 2.875rem;
                    max-height: 2.875rem;
                }
            }

            &.notification-event-marker {
                &:before,
                &:after {
                    display: none;
                }
            }

            &.leaflet-editing-icon {
                &:after,
                &:before {
                    display: none;
                }
            }

            .svg-icon-unit-marker {
                fill: currentColor;
                height: 2rem;
                width: 2rem;
            }
        }

        .leaflet-tooltip {
            border: none;
            background: rgba(var(--map-lable-bg-rgb), .9);
            white-space: nowrap;
            //width: max-content;
            padding: 0 .5rem;
            border-radius: .6875rem;
            //left: 50%;
            //transform: translate(-50%, 0);
            position: absolute;
            top: 10px;
            @include font(13px, 1.375rem, 600, none, normal, var(--color-font));
            height: 1.375rem;
            box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), 0.15);
            //max-width: 10rem;
            //overflow: hidden;
            //text-overflow: ellipsis;
        }
        .leaflet-tooltip-bottom{
            &:before {
                border-bottom-color: rgba(var(--map-lable-bg-rgb), .9);
            }
        }

        .leaflet-draw-tooltip {
            border: none;
            white-space: nowrap;
            width: max-content;
            padding: .25rem .5rem;
            border-radius: var(--border-radius-lg);
            position: absolute;
            @include font(13px, 1rem, 600, none, normal, var(--color-font));
            //height: 1.375rem;
            box-shadow: 0 0 12px 0 rgba(var(--color-neutral-700-rgb), 0.15);
            //max-width: 10rem;
            //overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .shipment-icon{
        display: flex;
        justify-content: center;
        &.leaflet-marker-icon {
            &:before,
            &:after {
                content: none !important;
            }
        }

        .shipment-track-point {
            $shipmentTrackPointBg: #3684DB;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            img {
                width: 80%;
            }

            &__text {
                display: flex;
                color: white;
                text-align: center;
                font-family: Inter, Sans-serif;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                justify-content: center;
                align-items: center;
                background: $shipmentTrackPointBg;
                border-radius: 100%;
                width: 30px;
                height: 30px;
            }

            &__line {
                display: flex;
                flex: 1;
                width: 2px;
                background: $shipmentTrackPointBg;
                position: relative;
            }
            &__line-point {
                position: absolute;
                display: block;
                background: rgba(54, 132, 219, 0.5);
                border-radius: 100%;
                bottom: 0;
                left: 50%;
                width: 20px;
                height: 20px;
                transform: translateX(-50%) translateY(50%);

                &:after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translateX(-50%) translateY(-50%);
                    width: 6px;
                    height: 6px;
                    background: $shipmentTrackPointBg;
                    border-radius: 100%;
                    border: solid 2px white;
                    z-index: 1;
                }
            }
            &__start {
                background: rgb(4, 122, 251);
                img {
                    width: 60%;
                }
            }
            &__end {
                background: rgb(40, 178, 95);
                img {
                    width: 60%;
                }
            }
        }
    }
    .shipment-track-popup {
        &__address {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 5px;
            margin-bottom: 5px;
        }
        &__address-icon {
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: 80%;
            }
        }
    }
    .shipment-track-popup-item {
        $shipmentTrackPointBg: #3684DB;
        display: flex;
        gap: 10px;
        padding: 5px;
        border-radius: 5px;
        margin-bottom: 5px;
        background: #F6FBFF;
        &.danger{
            background: #fce6e1;
        }
        &__badge {
            width: 30px;
            height: 30px;
            min-width: 30px;
            min-height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: $shipmentTrackPointBg;
            border-radius: 100%;
            color: white;
            text-align: center;
            font-family: Inter, Sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;

            img {
                width: 60%;
            }
        }
        &__body-item {
            display: flex;
            gap: 5px;
        }
    }

    .leaflet-popup-pane {
        //background: red;

        .leaflet-popup-content-wrapper {
            border-radius: var(--border-radius-lg);
            background: var(--map-popup-bg);
            padding: 0;

            .leaflet-popup-content {
                //padding: .5rem 1rem;
                padding: .5rem .75rem;
                margin: 0;

                @include font(13px, 20px, 400, none, normal, var(--color-font));
            }
        }

        .leaflet-popup-tip-container {
            transform: translate(0, -1px);

            .leaflet-popup-tip {
                background: var(--map-popup-bg);
            }
        }

        .leaflet-popup-close-button {
            display: none;
        }
    }

    .track-layer-color-none {
        stroke: var(--color-font-light) !important;
        //stroke: var(--color-primary-500) !important;
    }

    //Old style
    /*.marker-cluster-track div{
      font-size: 11px;
      text-align: right;
      margin-top: 8px;
      color: #FFFFFF;
    }
    .marker-cluster-track div{
      width: 100%
    }
    .marker-cluster-track div span{
      display: block;
      position: relative;
      margin-left: 36px;
      text-align: center;
    }
    .marker-cluster-track div span.marker-count{
      margin-top: 0;
      width: 25px;
    }
    .marker-cluster-track div span.speed{
      margin-top: 3px;
      width: 50px;
    }
    .marker-cluster-track div span.large-speed{
      margin-top: 3px;
      width: 60px;
    }
    .marker-cluster-track.kmp-small{
      background: url("~@/assets/img/clusters/track_1_kph.png") no-repeat;
    }
    .marker-cluster-track.kmp-medium{
      background: url("~@/assets/img/clusters/track_3_kph.png") no-repeat;
    }
    .marker-cluster-track.kmp-large{
      background: url("~@/assets/img/clusters/track_2_kph.png") no-repeat;
    }
    .marker-cluster-track.mph-small{
      background: url("~@/assets/img/clusters/track_1_mph.png") no-repeat;
    }
    .marker-cluster-track.mph-medium{
      background: url("~@/assets/img/clusters/track_3_mph.png") no-repeat;
    }
    .marker-cluster-track.mph-large{
      background: url("~@/assets/img/clusters/track_2_mph.png") no-repeat;
    }
    .marker-cluster-track.small{
      background: url("~@/assets/img/clusters/track_1.png") no-repeat;
    }
    .marker-cluster-track.medium{
      background: url("~@/assets/img/clusters/track_3.png") no-repeat;
    }
    .marker-cluster-track.large{
      background: url("~@/assets/img/clusters/track_2.png") no-repeat;
    }*/

    /*.svg-icon-unit-marker {
      fill: currentColor;
      height: 32px;
      width: 32px;
    }*/
}
.map-bottom-right {
    .leaflet-container {
        .leaflet-control-container{
            .leaflet-top.leaflet-right{
                .leaflet-control-zoom {
                    .leaflet-control-zoom-in,
                    .leaflet-control-zoom-out {
                        height: 20px;
                        width: 20px;
                        &:after {
                            height: .5rem;
                            width: 0.125rem;
                        }
                        &:before{
                            width: .5rem;
                            height: 0.125rem;
                        }
                    }
                }
                .leaflet-control .map-control{
                    width: 20px;
                    height: 20px;
                }
                .leaflet-control-layers {
                    .leaflet-control-layers-toggle{
                        width: 20px;
                        height: 20px;
                        &:before{
                            width: 0.475rem;
                            height: 0.475rem;
                        }
                        &:after{
                            width: 0.4875rem;
                            height: 0.4875rem;
                            transform: translate(-50%, calc(-50% + 2px)) rotateX(55deg) rotateZ(45deg);
                        }
                    }
                }
                .leaflet-control-layers-expanded{
                    .leaflet-control-layers-list{
                        @include scroll(var(--color-white), var(--color-neutral-100));
                        height: 160px !important;
                        transform: translateY(-50%);
                        top: 0;
                        //bottom: 0;
                        left: auto;
                        right: 110%;
                        &:after{
                            top: 30px;
                        }
                    }
                }
            }
        }
    }
}
.prometheus-portal {
    .leaflet-container {
        .leaflet-control-container {
            .leaflet-top.leaflet-right {
                .leaflet-control-zoom {
                    .leaflet-control-zoom-in,
                    .leaflet-control-zoom-out {
                        height: 25px;
                        width: 25px;
                        &:after {
                            height: .5rem;
                            width: 0.125rem;
                        }
                        &:before{
                            width: .5rem;
                            height: 0.125rem;
                        }
                    }
                }
                .leaflet-control-layers-toggle {
                    width: 25px;
                    height: 25px;
                    &:before{
                        width: 0.4rem;
                        height: 0.4rem;
                    }
                    &:after{
                        width: 0.4rem;
                        height: 0.4rem;
                        transform: translate(-50%, calc(-50% + 2px)) rotateX(55deg) rotateZ(45deg);
                    }
                }
                .leaflet-control .map-control{
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
}
</style>